import { HttpResponse, HttpService } from '@application/http.service';
import { SessionExpirationInformationApiModel } from '@visiba/api-vcs-client-v2';
import { Injectable, Scopes } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_base_client';

@Injectable({
	scope: Scopes.Transient,
})
export class SessionApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('session');
	}

	public getGuestSession(): HttpResponse<SessionExpirationInformationApiModel> {
		return this.httpService.get(`${this.baseUri}/guest`);
	}
}
